import { gql } from '@apollo/client';

export type SaveTtLocationConfigInput = {
  id?: number;
  parentId?: number | null;
  locationType: number;
  code: string;
  name: string;
  labelCode?: string | null;
  sortOrder?: number | null;
};

export const SAVE_TT_LOCATION_CONFIG = gql`
  mutation SaveTtLocationConfig($input: SaveTtLocationConfigInput!) {
    saveTtLocationConfig(input: $input) {
      id
      name
    }
  }
`;

export const DELETE_TT_LOCATION_CONFIG = gql`
  mutation DeleteTtLocationConfig($id: Long!) {
    deleteTtLocationConfig(id: $id)
  }
`;
